/**
 * Génère un UUID v4 simple
 */
export const generateId = (): string => {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }

  // Fallback pour les navigateurs plus anciens
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = Math.random() * 16 | 0;
    const v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
};

/**
 * Formate un nombre en FCFA
 */
export const formatCurrency = (amount: number): string => {
  return `${amount.toLocaleString('fr-FR')} FCFA`;
};

/**
 * Calcule l'âge à partir d'une date de naissance
 */
export const calculateAge = (birthDate: string): number => {
  const today = new Date();
  const birth = new Date(birthDate);
  let age = today.getFullYear() - birth.getFullYear();
  const monthDiff = today.getMonth() - birth.getMonth();

  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birth.getDate())) {
    age--;
  }

  return age;
};

/**
 * Calcule l'ancienneté en années et mois
 */
export const calculateAnciennete = (startDate: string): { annees: number; mois: number } => {
  const debut = new Date(startDate);
  const maintenant = new Date();
  const diffMs = maintenant.getTime() - debut.getTime();
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
  const annees = Math.floor(diffDays / 365);
  const mois = Math.floor((diffDays % 365) / 30);

  return { annees, mois };
};

/**
 * Valide un numéro de téléphone ivoirien
 */
export const validatePhoneNumber = (phone: string): boolean => {
  const regex = /^(\+225|00225|0)?[0-9]{10}$/;
  return regex.test(phone.replace(/\s/g, ''));
};

/**
 * Valide une adresse email
 */
export const validateEmail = (email: string): boolean => {
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return regex.test(email);
};
